import { removePrefix } from 'utils/string';

const NBSP = '\u00a0';
const EMPTY_ACCOUNT_PREFIX = '000000-';

/**
 * Formats a Czech account number (`prefix-number/bank`) for display: drops the
 * empty `000000-` prefix the backend sends and puts non-breaking spaces around `/`.
 *
 * @example
 * formatBankAccount('000000-1234567890/0100'); // '1234567890 / 0100'
 */
export function formatBankAccount(account: string): string {
  return removePrefix(account, EMPTY_ACCOUNT_PREFIX).replace(
    '/',
    `${NBSP}/${NBSP}`,
  );
}
